import useScrollReset from 'hooks/scroll_reset';

const ScrollReset = () => {
  useScrollReset();

  return null;
};

export default ScrollReset;
